import stickybits from 'stickybits';

import { breakpoints } from '../util/breakpoints';

/**
 * Offset in pixel the buying box should have to above elements.
 *
 * @type {number}
 */
const STICKY_OFFSET = 44;

/**
 * Returns the height of the header element.
 *
 * @returns {number}
 */
const getHeaderHeight = () => {
    const $header = document.querySelector('.header-wrapper');

    return $header ? $header.getBoundingClientRect().height : 0;
};

/**
 * Initializes sticky functionality of buying box.
 *
 * @param {String} buyingBoxSelector
 */
const initSticky = (buyingBoxSelector) => {
    const $buyingBox = document.querySelector(buyingBoxSelector);
    const $scrollToTopBtn = document.querySelector('.scroll-up-button');
    const currentBodyMarginBottom = parseFloat(window.getComputedStyle(document.body).marginBottom);
    const sticky = stickybits(buyingBoxSelector, {
        stickyBitStickyOffset: getHeaderHeight() + STICKY_OFFSET,
    });


    // Run it once
    stick(sticky, $buyingBox, $scrollToTopBtn, currentBodyMarginBottom);

    // Then a listener for responsive.
    window.addEventListener('resize', () => {
        stick(sticky, $buyingBox, $scrollToTopBtn, currentBodyMarginBottom);
    });
};

const stick = (sticky, $buyingBox, $scrollToTopBtn, currentBodyMarginBottom) => {
    const HEIGHT_VUE_BOTTOM_BAR = 56; // 56px from VueBottomBar -> BottomBar.vue

    // The sticky is required on Desktop, but not on Mobile.
    // So we have a check here, if on Desktop, proceed like normal. Otherwise, disable sticky and reposition the body.
    if (window.innerWidth > breakpoints.TABLET) {
        // Desktop
        sticky.update();
        document.body.style.marginBottom = ''; // unset it
        $scrollToTopBtn.style.bottom = ''; // unset it
    } else {
        // Mobile
        // First, we remove the sticky, since we have position:fixed already!
        sticky.cleanup();
        // Then, we pad the body to include the height of the sticky buying box!
        // The timer is needed for the time it takes to switch from Desktop to Mobile buying box.
        setTimeout(() => {
            let heightBuyingBoxMobile = parseFloat(window.getComputedStyle($buyingBox).height);
            document.body.style.marginBottom = currentBodyMarginBottom + heightBuyingBoxMobile + 'px';
            // Then, we pad the scroll-to-top button to include the height of the sticky buying box!
            $scrollToTopBtn.style.bottom = HEIGHT_VUE_BOTTOM_BAR + heightBuyingBoxMobile + 'px';
        }, 100);
    }
};

(() => {
    const buyingBoxSelector = '.cms-element-buy-box';
    const $buyingBox = document.querySelector(buyingBoxSelector);

    if (!$buyingBox) {
        return;
    }

    initSticky(buyingBoxSelector);
})();
